import moment from 'moment';
import { VoucherOut } from '../../../../api';
import { DATE_FORMAT } from '../../../calendarWrapper/CalendarWrapper';
import { CalendarSlot } from '../../../CalendarContext/SlotActionsMenu/CalendarSlot';

export const NINE_AM = 60 * 60 * 9;
export const SLOT_SECONDS = 30 * 60;

export const getNowRoundedDownSeconds = () => {
  const now = moment();
  const secondsSinceMidnight = now.diff(now.clone().startOf('day'), 'seconds');
  return Math.floor(secondsSinceMidnight / SLOT_SECONDS) * SLOT_SECONDS;
};

export const getInitialOrder = (
  parent: any,
  shouldPrefillNow: boolean,
  defaultDate: string,
  voucher?: VoucherOut,
  slot?: CalendarSlot,
) => {
  let date = defaultDate;
  let time = shouldPrefillNow && defaultDate === moment().format(DATE_FORMAT) ? getNowRoundedDownSeconds() : NINE_AM;
  if (slot) {
    date = slot.date;
    time = slot.startSeconds;
  }
  if (parent) {
    date = parent.date;
    time = parent.time;
  }
  return {
    date,
    time,
    firstname: voucher?.firstname || '',
    lastname: voucher?.lastname || '',
    alternative_full_name: undefined,
    phone: voucher?.phone,
    email: voucher?.email || '',
    custom_details: voucher?.custom_details || undefined,
    voucher_greeting_message: voucher?.voucher_greeting_message || undefined,
    recipient_email: voucher?.recipient_email || undefined,
    delivery_timestamp: voucher?.delivery_timestamp || undefined,
  };
};
